var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 72068"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 362",
    cx: 11.5,
    cy: 11.5,
    r: 10.5,
    stroke: "#8B68DD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M12.503 6.75391L12.3325 13.3194H10.6537L10.4832 6.75391H12.503ZM11.5062 16.246C10.8898 16.246 10.3914 15.7539 10.4045 15.1582C10.3914 14.5625 10.8898 14.0834 11.5062 14.0834C12.0833 14.0834 12.5948 14.5625 12.5948 15.1582C12.5948 15.7539 12.0833 16.246 11.5062 16.246Z",
    fill: "#8B68DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionInfo);
export default __webpack_public_path__ + "static/media/permission-info.dccab05c898ec00723ab720203a253e3.svg";
export { ForwardRef as ReactComponent };